import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { VideoInfoModalService } from '@core/components/video-info-modal/video-info-modal.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { PushNotificationsService } from '@core/services/push-notifications/push-notifications.service';
import { SocketService } from '@core/services/socket.service';
import { delay } from '@core/utils/delay';
import { getErrorCode } from '@core/utils/get-error-code';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { PasswordValidation } from '@validators/password-validation';
import { ReadRecoveryCodesComponent } from 'app/main/settings/profile/dialogs/read-recovery-codes-dialog/read-recovery-codes.component';
import { MfaService } from 'app/main/settings/profile/services/mfa.service';
import { sentry } from 'sentry';
import { environment } from '../../../../../environments/environment';
import { UserLookupService } from '../../services/api/user-lookup.api.service';
import { LoginResolver } from '../../services/login.resolver';
var LoginAuthComponent = /** @class */ (function () {
    function LoginAuthComponent(matDialog, mfaService, formBuilder, socketService, loginResolver, activatedRoute, userLookupService, navigationService, fuseProgressBar, customMessageService, authenticationService, pushNotificationsService, videoInfoModalService, http) {
        this.matDialog = matDialog;
        this.mfaService = mfaService;
        this.formBuilder = formBuilder;
        this.socketService = socketService;
        this.loginResolver = loginResolver;
        this.activatedRoute = activatedRoute;
        this.userLookupService = userLookupService;
        this.navigationService = navigationService;
        this.fuseProgressBar = fuseProgressBar;
        this.customMessageService = customMessageService;
        this.authenticationService = authenticationService;
        this.pushNotificationsService = pushNotificationsService;
        this.videoInfoModalService = videoInfoModalService;
        this.http = http;
        this.loginStep = 'email';
        this.isLoading = false;
        this.lookupResult = null;
        this.extraAuthInfo = null;
        this.recoveryCodeInput = null;
        this.verificationCodeForm = null;
        this.loginCustomization = this.loginResolver.loginCustomization;
        var email = this.activatedRoute.snapshot.queryParams.email || null;
        this.loginForm = this.formBuilder.group({
            email: [email, [Validators.required, Validators.email, Validators.pattern(/@.+\./)]],
            password: [null, [Validators.required]]
        });
    }
    LoginAuthComponent.prototype.authWithAd = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var email, openIdConfiguration, url;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        email = this.loginForm.getRawValue().email;
                        return [4 /*yield*/, this.http.get(environment.MORANNON_URL + '/open-id-configuration', {
                                params: {
                                    slug: this.lookupResult.slug
                                }
                            }).toPromise()];
                    case 1:
                        openIdConfiguration = _a.sent();
                        url = new URL(openIdConfiguration.authorization_endpoint);
                        url.searchParams.append('client_id', this.lookupResult.clientId);
                        url.searchParams.append('response_type', 'id_token');
                        url.searchParams.append('redirect_uri', environment.MOUNTDOOM_URL + "/auth-redirect/index.html");
                        url.searchParams.append('scope', 'openid profile email');
                        url.searchParams.append('nonce', Math.random().toString(36).substring(7));
                        url.searchParams.append('login_hint', email);
                        url.searchParams.append('state', encodeURIComponent(JSON.stringify({
                            provider: 'active-directory',
                            callbackUrl: environment.MOUNTDOOM_URL + "/#/login/redirecionando"
                        })));
                        location.href = url.toString();
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginAuthComponent.prototype.authWithGoogle = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var email, url;
            return tslib_1.__generator(this, function (_a) {
                email = this.loginForm.getRawValue().email;
                url = new URL('https://accounts.google.com/o/oauth2/v2/auth');
                url.searchParams.append('client_id', '508717818542-s5m9fdbsi71kicmssor6fd2ojeijki8p.apps.googleusercontent.com');
                url.searchParams.append('redirect_uri', "https://fornecedores.fieldcontrol.com.br/auth-redirect/index.html");
                url.searchParams.append('response_type', 'id_token');
                url.searchParams.append('scope', 'openid profile email');
                url.searchParams.append('access_type', 'offline');
                url.searchParams.append('nonce', Math.random().toString(36).substring(7));
                url.searchParams.append('login_hint', email);
                url.searchParams.append('prompt', 'select_account');
                url.searchParams.append('state', encodeURIComponent(JSON.stringify({
                    provider: 'google',
                    callbackUrl: environment.MOUNTDOOM_URL + "/#/login/redirecionando"
                })));
                location.href = url.toString();
                return [2 /*return*/];
            });
        });
    };
    LoginAuthComponent.prototype.auth = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, email, password, err_1, code;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, 4, 5]);
                        this.isLoading = true;
                        this.fuseProgressBar.show();
                        _a = this.loginForm.getRawValue(), email = _a.email, password = _a.password;
                        this.loginForm.get('password').markAsTouched();
                        return [4 /*yield*/, this.authenticationService.login({ provider: 'email-password', email: email, password: password })];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.refreshItemsAndConnectSocket()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        code = getErrorCode(err_1);
                        if (code === 'NewPasswordRequired') {
                            this.toNewPasswordStep();
                            return [2 /*return*/];
                        }
                        if (code === 'SoftwareTokenMfaRequired') {
                            this.toSoftwareTokenStep();
                            return [2 /*return*/];
                        }
                        if (code === 'ExpiredPassword') {
                            this.toNewPasswordStep(true);
                            return [2 /*return*/];
                        }
                        if (code === 'ExpiredPasswordSoon') {
                            this.extraAuthInfo = err_1.error.response;
                            this.loginStep = 'expiredSoonPassword';
                            return [2 /*return*/];
                        }
                        if (code === 'NotAuthorizedException') {
                            this.setLoginError({ message: err_1.error.message, code: code });
                            return [2 /*return*/];
                        }
                        this.setLoginError({ message: err_1.error.message, code: code });
                        if (this.loginForm.get('password').valid) {
                            this.loginForm.get('password').setErrors({ unknown: true });
                        }
                        console.log('[DEBUG ERROR]: ', err_1);
                        sentry.captureException(err_1, {
                            user: {
                                email: this.loginForm.get('email').value
                            },
                            extra: {
                                message: 'Error on authentication',
                                err: JSON.stringify(err_1)
                            }
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.isLoading = false;
                        this.fuseProgressBar.hide();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    LoginAuthComponent.prototype.authWithSoftwareToken = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_2, code;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.isLoading = true;
                        this.fuseProgressBar.show();
                        return [4 /*yield*/, this.authenticationService.loginWithSoftwareToken({
                                email: this.loginForm.get('email').value,
                                code: this.verificationCodeForm.value.join('')
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.refreshItemsAndConnectSocket()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        err_2 = _a.sent();
                        code = getErrorCode(err_2);
                        if (code === 'CodeMismatchException') {
                            this.verificationCodeForm.setErrors({ incorrect: true });
                            return [2 /*return*/];
                        }
                        if (code === 'NotAuthorizedException') {
                            this.loginForm.reset();
                            this.loginStep = 'email';
                            this.customMessageService.error('LOGIN.AUTH.MFA.EXPIRED_CODE');
                            this.verificationCodeForm.reset();
                            return [2 /*return*/];
                        }
                        if (code === 'UnauthorizedUser') {
                            this.loginForm.reset();
                            this.loginStep = 'email';
                            this.customMessageService.error('LOGIN.AUTH.ERRORS.UNAUTHORIZED');
                            this.verificationCodeForm.reset();
                            return [2 /*return*/];
                        }
                        this.customMessageService.error('LOGIN.AUTH.ERRORS.UNKNOWN');
                        console.error(err_2);
                        sentry.captureException(err_2, {
                            user: {
                                email: this.loginForm.get('email').value
                            },
                            extra: {
                                message: 'Error on authentication with verification code',
                                err: JSON.stringify(err_2)
                            }
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.isLoading = false;
                        this.fuseProgressBar.hide();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    LoginAuthComponent.prototype.authWithRecoveryCode = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var recoveryCodes, allCodesIsUsed, err_3, code;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, 5, 6]);
                        this.isLoading = true;
                        this.fuseProgressBar.show();
                        this.recoveryCodeInput.markAsTouched();
                        return [4 /*yield*/, this.authenticationService.loginWithRecoveryCode({
                                email: this.loginForm.get('email').value,
                                password: this.loginForm.get('password').value,
                                recoveryCode: this.recoveryCodeInput.value
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.mfaService.getRecoveryCodes({
                                accessToken: this.authenticationService.accessToken
                            })];
                    case 2:
                        recoveryCodes = _a.sent();
                        return [4 /*yield*/, this.refreshItemsAndConnectSocket()];
                    case 3:
                        _a.sent();
                        allCodesIsUsed = recoveryCodes.every(function (_a) {
                            var status = _a.status;
                            return status === 'CURRENT_USED';
                        });
                        if (allCodesIsUsed) {
                            this.matDialog
                                .open(ReadRecoveryCodesComponent, {
                                panelClass: 'read-recovery-codes',
                                disableClose: true,
                                autoFocus: false,
                                data: {
                                    recoveryCodes: recoveryCodes,
                                    me: this.authenticationService.user,
                                    type: 'all-used',
                                    step: 2,
                                }
                            });
                        }
                        return [3 /*break*/, 6];
                    case 4:
                        err_3 = _a.sent();
                        code = getErrorCode(err_3);
                        if (['InvalidRecoveryCode', 'RecoveryCodeMismatch'].includes(code)) {
                            this.recoveryCodeInput.setErrors({ incorrect: true });
                            return [2 /*return*/];
                        }
                        if (code === 'RecoveryCodeRevoked') {
                            this.recoveryCodeInput.setErrors({ revoked: true });
                            return [2 /*return*/];
                        }
                        if (code === 'RecoveryCodeAlreadyUsed') {
                            this.recoveryCodeInput.setErrors({ used: true });
                            return [2 /*return*/];
                        }
                        sentry.captureException(err_3, {
                            user: {
                                email: this.loginForm.get('email').value
                            },
                            extra: {
                                message: 'Error on authentication with recovery code',
                                err: JSON.stringify(err_3)
                            }
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        this.isLoading = false;
                        this.fuseProgressBar.hide();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    LoginAuthComponent.prototype.authWithExpiringPassword = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.extraAuthInfo.challengeName === 'SOFTWARE_TOKEN_MFA') {
                            this.toSoftwareTokenStep();
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        this.isLoading = true;
                        this.fuseProgressBar.show();
                        return [4 /*yield*/, this.authenticationService.updateStateAndSetRefreshToken(this.extraAuthInfo)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.refreshItemsAndConnectSocket()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        err_4 = _a.sent();
                        this.loginStep = 'email';
                        sentry.captureException(err_4);
                        return [3 /*break*/, 6];
                    case 5:
                        this.isLoading = false;
                        this.fuseProgressBar.hide();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    LoginAuthComponent.prototype.createNewPassword = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var input, err_5, code;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        input = {
                            email: this.loginForm.get('email').value,
                            newPassword: this.resetPasswordForm.get('password').value
                        };
                        this.isLoading = true;
                        this.fuseProgressBar.show();
                        this.loginForm.reset();
                        this.resetPasswordForm.reset();
                        return [4 /*yield*/, this.authenticationService.createNewPassword(input)];
                    case 1:
                        _a.sent();
                        this.loginStep = 'successOnResetPassword';
                        return [3 /*break*/, 4];
                    case 2:
                        err_5 = _a.sent();
                        code = getErrorCode(err_5);
                        if (['InvalidParameterException', 'InvalidPasswordException'].includes(code)) {
                            this.resetPasswordForm.get('password').setErrors({ pattern: true });
                            return [2 /*return*/];
                        }
                        if (code === 'SoftwareTokenMfaRequired') {
                            this.toSoftwareTokenStep();
                            return [2 /*return*/];
                        }
                        if (code === 'LimitExceededException') {
                            this.resetPasswordForm.setErrors({ limitExceeded: true });
                            return [2 /*return*/];
                        }
                        this.resetPasswordForm.setErrors({ unknown: true });
                        sentry.captureException(err_5, {
                            user: {
                                email: this.loginForm.get('email').value
                            },
                            extra: {
                                message: 'Error on createNewPasswordAfterTemporary',
                                err: JSON.stringify(err_5)
                            },
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        this.isLoading = false;
                        this.fuseProgressBar.hide();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LoginAuthComponent.prototype.createNewPasswordAfterExpiredAndLogin = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newPassword, _a, err_6, code;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 4, 5, 6]);
                        this.isLoading = true;
                        this.fuseProgressBar.show();
                        newPassword = this.resetPasswordForm.get('password').value;
                        _a = this;
                        return [4 /*yield*/, this.authenticationService.createNewPasswordAfterExpiredAndLogin(newPassword)];
                    case 1:
                        _a.extraAuthInfo = _b.sent();
                        return [4 /*yield*/, this.authenticationService.updateStateAndSetRefreshToken(this.extraAuthInfo)];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.refreshItemsAndConnectSocket()];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        err_6 = _b.sent();
                        code = getErrorCode(err_6);
                        if (code === 'NewUserPasswordHasBeenUsedBefore') {
                            this.resetPasswordForm.get('password').setErrors({ usedBefore: true });
                            return [2 /*return*/];
                        }
                        if (code === 'SignInWithNewPasswordInvalidSession') {
                            this.loginStep = 'email';
                            return [2 /*return*/];
                        }
                        if (['InvalidParameterException', 'InvalidPasswordException'].includes(code)) {
                            this.resetPasswordForm.get('password').setErrors({ pattern: true });
                            return [2 /*return*/];
                        }
                        if (code === 'SoftwareTokenMfaRequired') {
                            this.toSoftwareTokenStep();
                            return [2 /*return*/];
                        }
                        if (code === 'LimitExceededException') {
                            this.resetPasswordForm.setErrors({ limitExceeded: true });
                            return [2 /*return*/];
                        }
                        this.resetPasswordForm.setErrors({ unknown: true });
                        sentry.captureException(err_6, {
                            user: {
                                email: this.loginForm.get('email').value
                            },
                            extra: {
                                message: 'Error on createNewPasswordAfterExpiredAndLogin',
                                err: JSON.stringify(err_6)
                            },
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        this.isLoading = false;
                        this.fuseProgressBar.hide();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    LoginAuthComponent.prototype.onClickBackToLogin = function () {
        this.loginStep = 'email';
    };
    LoginAuthComponent.prototype.setLoginError = function (_a) {
        var _b;
        var message = _a.message, code = _a.code;
        var mappedErrors = {
            'User is disabled.': 'disabled',
            'Password attempts exceeded': 'passwordAttemptsExceeded',
            'UserNotFoundException': 'failed',
            'Incorrect username or password.': 'failed',
            'UnauthorizedUser': 'unauthorized',
            'Password reset required for the user': 'passwordResetRequired',
            'Temporary password has expired and must be reset by an administrator.': 'temporaryPasswordExpired',
        };
        var error = mappedErrors[message] || mappedErrors[code] || 'unknown';
        this.loginForm.get('password').setErrors((_b = {},
            _b[error] = true,
            _b));
    };
    LoginAuthComponent.prototype.toPasswordStep = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var email, _a, passwordInput, err_7;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        this.isLoading = true;
                        this.fuseProgressBar.show();
                        this.loginForm.get('email').markAsTouched();
                        email = this.loginForm.value.email.trim();
                        _a = this;
                        return [4 /*yield*/, this.userLookupService.lookupUserByEmail(email)];
                    case 1:
                        _a.lookupResult = _b.sent();
                        if (this.lookupResult.code === 'not_found') {
                            this.lookupResult.name = email.split(/@|\./g)[0];
                        }
                        if (!this.lookupResult.loginIntegrationEnabled) return [3 /*break*/, 2];
                        if (this.lookupResult.loginProvider === 'active-directory') {
                            this.authWithAd();
                        }
                        if (this.lookupResult.loginProvider === 'google') {
                            this.authWithGoogle();
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        this.loginStep = 'password';
                        return [4 /*yield*/, delay(300)];
                    case 3:
                        _b.sent();
                        passwordInput = document.querySelector('input[type=password]');
                        if (passwordInput) {
                            passwordInput.focus();
                        }
                        this.isLoading = false;
                        this.fuseProgressBar.hide();
                        _b.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_7 = _b.sent();
                        sentry.captureException(err_7, {
                            user: {
                                email: this.loginForm.get('email').value
                            },
                            extra: {
                                message: 'Error on login',
                                err: JSON.stringify(err_7)
                            }
                        });
                        this.isLoading = false;
                        this.fuseProgressBar.hide();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    LoginAuthComponent.prototype.toRecoveryCodeStep = function () {
        this.recoveryCodeInput = new FormControl(null, [Validators.required]);
        this.loginStep = 'recoveryCode';
    };
    LoginAuthComponent.prototype.toSoftwareTokenStep = function () {
        this.verificationCodeForm = this.formBuilder.array([
            new FormControl(null, [Validators.required]),
            new FormControl(null, [Validators.required]),
            new FormControl(null, [Validators.required]),
            new FormControl(null, [Validators.required]),
            new FormControl(null, [Validators.required]),
            new FormControl(null, [Validators.required])
        ]);
        this.loginStep = 'softwareToken';
    };
    LoginAuthComponent.prototype.toNewPasswordStep = function (isExpired) {
        this.resetPasswordForm = this.formBuilder.group({
            password: [null, [
                    Validators.required,
                    Validators.minLength(8),
                    Validators.pattern(new RegExp('[0-9]{1,}')),
                    Validators.pattern(new RegExp('[a-z]{1,}')),
                    Validators.pattern(new RegExp('[A-Z]{1,}')),
                    Validators.pattern(/\^|\$|\*|\.|\[|\]|\{|\}|\(|\)|\?|\-|\"|\!|\@|\#|\%|\&|\/|\\|\,|\>|\<|\'|\:|\;|\||\_|\~|\`|\+|\='/)
                ]],
            confirmPassword: [null, Validators.required]
        }, {
            validator: PasswordValidation.validate.bind(this)
        });
        this.loginStep = isExpired ? 'expiredPassword' : 'resetPassword';
    };
    LoginAuthComponent.prototype.refreshItemsAndConnectSocket = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var firstVisibleItem, redirectToDestinationUrl;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        firstVisibleItem = this.navigationService.getFirstVisibleItem(true);
                        redirectToDestinationUrl = localStorage.getItem('REDIRECT_TO_URL_AFTER_LOGIN');
                        location.href = redirectToDestinationUrl || firstVisibleItem.url;
                        if (redirectToDestinationUrl) {
                            localStorage.removeItem('REDIRECT_TO_URL_AFTER_LOGIN');
                        }
                        this.navigationService.showSupplierIndicationPopUpForCurrentMonth();
                        return [4 /*yield*/, this.pushNotificationsService.refreshNotificationSubscription()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.socketService.reconnect()];
                    case 2:
                        _a.sent();
                        window.dispatchEvent(new Event('refresh-notification-count'));
                        return [2 /*return*/];
                }
            });
        });
    };
    return LoginAuthComponent;
}());
export { LoginAuthComponent };
